import { convertKebabToCamel } from "./convertKebabToCamel";

describe("convertKebabToCamel", () => {
    it("converts a kebab-case string to camel-case", () => {
        const input = "kebab-case-string";
        const oputput = convertKebabToCamel(input);
        expect(oputput).toBe("kebabCaseString");
    });

    it("leaves a non-kebab string equal", () => {
        const input = "astring";
        const oputput = convertKebabToCamel(input);
        expect(oputput).toBe("astring");
    });

    it("leaves a camel-case string equal", () => {
        const input = "camelCaseString";
        const oputput = convertKebabToCamel(input);
        expect(oputput).toBe("camelCaseString");
    });
});
